module.exports = __webpack_public_path__ + "c42c685694dcfda4dbc67dbba01de41f.svg";